/* tslint:disable */
/* eslint-disable */
/* @relayHash 27475ef4d781798c120a2b268cdc7327 */

import { ConcreteRequest } from "relay-runtime";
export type CreateDesignProjectMutationInput = {
    firmId: number;
    clientMutationId?: string | null;
};
export type createDesignProjectMutationVariables = {
    input: CreateDesignProjectMutationInput;
};
export type createDesignProjectMutationResponse = {
    readonly createDesignProject: {
        readonly project: {
            readonly internalEditUrl: string | null;
            readonly editUrl: string | null;
        } | null;
    } | null;
};
export type createDesignProjectMutation = {
    readonly response: createDesignProjectMutationResponse;
    readonly variables: createDesignProjectMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateDesignProjectMutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "internalEditUrl",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "editUrl",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "createDesignProjectMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createDesignProject",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateDesignProjectMutationPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "project",
            "storageKey": null,
            "args": null,
            "concreteType": "designProject",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "createDesignProjectMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createDesignProject",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateDesignProjectMutationPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "project",
            "storageKey": null,
            "args": null,
            "concreteType": "designProject",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "createDesignProjectMutation",
    "id": "app-buyer-trade/267.0.0-2020-06-02T16:23:38.038Z/createDesignProjectMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'e2600b22615448d9f3f0c8fd64b50023';
export default node;
